import { render, staticRenderFns } from "./BInputWithValidation.vue?vue&type=template&id=3cdab663&"
import script from "./BInputWithValidation.vue?vue&type=script&lang=js&"
export * from "./BInputWithValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports